/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './subscribeRepos.defs.js'
export * as $defs from './subscribeRepos.defs.js'
